import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=a6bfeb1c"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6bfeb1c')) {
      api.createRecord('a6bfeb1c', component.options)
    } else {
      api.reload('a6bfeb1c', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=a6bfeb1c", function () {
      api.rerender('a6bfeb1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/customform/edit.vue"
export default component.exports